
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null">
    <h1 class="content-heading-font">Clients</h1>


    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 [multiSortMeta]="[{field: 'SiteName', order: 1}]"
                 sortMode="multiple"
                 [filters]="{Active: [{ value: 'true', matchMode: 'contains', operator: 'and'}]}">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">#<p-sortIcon field="ID"></p-sortIcon></th>
              <th pSortableColumn="SiteName" class="text-start">
                Site Name
                <p-sortIcon field="SiteName"></p-sortIcon>
                <p-columnFilter type="text" field="SiteName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="BusinessName" class="text-star d-none d-lg-table-cell">
                Business Name <p-sortIcon field="BusinessName"></p-sortIcon>
                <p-columnFilter type="text" field="BusinessName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="BusinessGroupName" class="text-star d-none d-xl-table-cell">
                Business Group <p-sortIcon field="BusinessGroupName"></p-sortIcon>
                <p-columnFilter type="text" field="BusinessGroupName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Active" class="text-start d-none d-lg-table-cell">
                Status <p-sortIcon field="Active"></p-sortIcon>
                <p-columnFilter type="boolean" field="Active" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'Hidden', value: 'false' },{ name: 'Active', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="OpenTickets" class="text-end d-none d-md-table-cell">
                Tickets <p-sortIcon field="OpenTickets"></p-sortIcon>
                <p-columnFilter type="numeric" field="OpenTickets" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block text-">
                  <a class="btn btn-sm btn-secondary me-1  " (click)="onRowView(item)" title="Impersonate Client">
                    <i class="pi pi-key"></i>
                  </a>
                  <a class="btn btn-sm btn-primary me-1 " (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-secondary me-1 " [routerLink]="['/client/'+  item.ID ]" title="view">
                    <i class="pi pi-building"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>

              <td>
                <a href="#" [routerLink]="['/client/'+  item.ID ]">
                  <img [src]="getClientLogo(item)" class="smallBussinesLogo" *ngIf="item.Active" /> {{ item.SiteName }}
                </a>
              </td>
              <td class=" d-none d-lg-table-cell">{{ item.BusinessName }}</td>
              <td class=" d-none d-xl-table-cell">{{ item.BusinessGroupName }}</td>
              <td class=" d-none d-lg-table-cell fw-bold">
                <div [ngClass]="{'text-danger': !item.Active, 'text-success': item.Active}">
                  {{ !item.Active?'Hidden':'Active' }}
                </div>
              </td>
              <td class="text-end d-none d-md-table-cell">
                <a href="#" [routerLink]="['/tickets']" [queryParams]="{clientID: item.ID}">
                  {{ item.CriticalTickets |  number  }} / {{ item.OpenTickets |  number }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="addItem(dt1)" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refress">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">
      <img [src]="getClientLogo(currentItem)" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem.Active" />
      {{currentItem.BusinessName || currentItem.SiteName }}
    </h1>


    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="SiteName">Site Name</label>
          <input class="form-control" name="SiteName" formControlName="SiteName" autocomplete="off" placeholder="SiteName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="BusinessName">Business Name</label>
          <input class="form-control" name="BusinessName" formControlName="BusinessName" autocomplete="off" placeholder="Business Name"/>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="BusinessGroupName">Business Group</label>
          <input class="form-control" name="BusinessGroupName" formControlName="BusinessGroupName" autocomplete="off" placeholder="Business Group Name"  />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Email">Email</label>
          <input class="form-control" name="Email" formControlName="Email" autocomplete="off" placeholder="Email" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="PhoneNumber">Phone Number</label>
          <input class="form-control" name="PhoneNumber" formControlName="PhoneNumber" autocomplete="off"  />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Active">Active </label>
          <select class="form-control" name="Active" formControlName="Active">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>



<p-dialog header="Login on {{clientLoginItem?.SiteName}}" [modal]="true" [(visible)]="clientLoginVisible" styleClass="p-dialog-no-scroll">
  <div class="row"  *ngIf="!clientLoginUrl">
    <div class="col mb-3" [class.div-loading]="loadingClientUsers">
      <label for="client_user">Client Username</label><br />

      <p-autoComplete class="form-control" name="client_user" [(ngModel)]="client_user" 
                      [dropdown]="true"
                      dropdownMode="current"
                      [forceSelection]="true"
                      [suggestions]="filteredClientUser"
                      (completeMethod)="filterClientUsers($event)"
                      [optionLabel]="labelClientUser"
                      autocomplete="off"
                      dataKey="ID"
                      minLength="0"></p-autoComplete>
    </div>
  </div>
  <div class="row" *ngIf="!clientLoginUrl">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnClientLogin" [class.button-loading]="loading" (click)="clientLogin()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnClientLoginCancel" [class.button-loading]="loading" (click)="clientLoginVisible=false">Cancel</button>
    </div>
  </div>
  <div class="row" *ngIf="clientLoginUrl">
    <div class="col mb-3 text-body-emphasis" >
      <a href="{{clientLoginUrl}}" target="{{clientLoginItem?.SiteName}}">https://{{clientLoginItem?.SiteName?.toLowerCase()}}.{{this.baseDomain}}</a>
    </div>
  </div>
</p-dialog>
